import { DEPENDENCY_SCHEDULE_PATH } from '@routes/paths';
import { RouteErrorBoundry } from '@routes/RouteErrorBoundary';

const dependencyUpdatesScheduleRoutes = [
  {
    path: DEPENDENCY_SCHEDULE_PATH.path,
    errorElement: <RouteErrorBoundry />,
    async lazy() {
      const { MintMakerSchedulePage: Component } = await import(
        '~/components/MintMaker/Schedule/MintMakerSchedulePage' /* webpackChunkName: "mintmaker-schedule" */
      );

      return { Component };
    },
  },
];

export default dependencyUpdatesScheduleRoutes;
